import { globalVariables } from "helper/globalVariables";

export const dogsOptions = [
  "Dog1",
  "Dog2",
  "Dog3",
  "Dog4",
  "Dog5",
  "Dog6",
  "Dog7",
  "Dog8",
  "Dog9",
  "Dog10",
  "Dog11",
  "Dog12",
  "Dog13",
  "Dog14",
  "Dog15",
];
export const divisionOptions = ["Division1", "Division2", "Division3"];
export const elementsOptions = ["Elements1", "Elements2", "Elements3"];

export const dropdowns = [
  {
    name: "dog",
    placeHolder: globalVariables.dogDropdown,
    errorMsg: globalVariables.dogDropdownRequired,
    options: dogsOptions,
  },
  {
    name: "division",
    placeHolder: globalVariables.division,
    errorMsg: globalVariables.divisionRequired,
    options: divisionOptions,
  },
  {
    name: "elements",
    placeHolder: globalVariables.elements,
    errorMsg: globalVariables.elementsRequired,
    options: elementsOptions,
  },
];
